/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const EyeOpenIcon: FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <g clipPath="url(#clip0_16049_3803)">
      <path
        d="M0.833252 10.8786C0.833252 10.8786 4.16658 4.21191 9.99992 4.21191C15.8333 4.21191 19.1666 10.8786 19.1666 10.8786C19.1666 10.8786 15.8333 17.5452 9.99992 17.5452C4.16658 17.5452 0.833252 10.8786 0.833252 10.8786Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99992 13.3786C11.3806 13.3786 12.4999 12.2593 12.4999 10.8786C12.4999 9.49787 11.3806 8.37858 9.99992 8.37858C8.61921 8.37858 7.49992 9.49787 7.49992 10.8786C7.49992 12.2593 8.61921 13.3786 9.99992 13.3786Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16049_3803">
        <rect width="20" height="20" fill="white" transform="translate(0 0.878906)" />
      </clipPath>
    </defs>
  </svg>
);
